import React from "react";
import PropTypes from "prop-types";
import { LoaderCircle } from "lucide-react";

export const Spinner = ({ label = "Loading", size = "default" }) => (
  <span className={`wsm-spinner wsm-spinner--${size}`} role="status">
    <LoaderCircle aria-hidden="true" />
    <span className="wsm-sr-only">{label}</span>
  </span>
);

Spinner.propTypes = { label: PropTypes.string, size: PropTypes.oneOf(["small", "default", "large"]) };

export const LoadingBlock = ({ label = "Loading content", lines = 4 }) => (
  <div className="wsm-loading-block" aria-busy="true" aria-label={label} role="status">
    <p aria-hidden="true" className="wsm-loading-block__label"><LoaderCircle />{label}</p>
    {Array.from({ length: lines }, (_, index) => <span className="wsm-skeleton" key={index} style={{ "--skeleton-width": index === lines - 1 ? "62%" : "100%" }} />)}
  </div>
);

LoadingBlock.propTypes = { label: PropTypes.string, lines: PropTypes.number };

export const TableSkeleton = ({ columns = 4, label = "Loading table data", rows = 5 }) => (
  <div className="wsm-table-skeleton" style={{ "--skeleton-columns": columns }} aria-busy="true" aria-label={label} role="status">
    <p aria-hidden="true" className="wsm-table-skeleton__label"><LoaderCircle />{label}</p>
    {Array.from({ length: rows * columns }, (_, index) => <span className="wsm-skeleton" key={index} />)}
  </div>
);

TableSkeleton.propTypes = { columns: PropTypes.number, label: PropTypes.string, rows: PropTypes.number };
